import type { FC } from 'react'

import linkGenerator, { type PositionalProperties } from 'modules/people_chart/lib/linkGenerator'

import './index.styles.css'
type Props = {
  source: PositionalProperties
  target: PositionalProperties
}
const Link: FC<Props> = ({ source, target }) => {
  const d = linkGenerator(source, target)

  if (!d) {
    return null
  }

  return <path d={d} className={'Link_link'} />
}

export default Link
